import API from 'api/api';

export const getAiCapabilities = async () => {
  const response = await API.get('/ai/capabilities');
  return Array.isArray(response.data?.capabilities) ? response.data.capabilities : [];
};

export const createAiSession = async (payload = {}) => {
  const response = await API.post('/ai/sessions', payload);
  return response.data;
};

export const getAiSession = async (sessionId) => {
  const response = await API.get(`/ai/sessions/${sessionId}`);
  return response.data;
};

export const deleteAiSession = async (sessionId) => {
  await API.delete(`/ai/sessions/${sessionId}`);
};

export const postAiEvent = async (payload = {}) => {
  await API.post('/ai/events', payload);
};

export const createAiLiveSession = async (payload = {}) => {
  const response = await API.post('/ai/live/sessions', payload);
  return response.data;
};

export const closeAiLiveSession = async (sessionId, payload = {}) => {
  const response = await API.post(`/ai/live/sessions/${sessionId}/close`, payload);
  return response.data;
};

export const getAiSessionMessages = async (sessionId, { skip = 0, limit = 20 } = {}) => {
  const response = await API.get(`/ai/sessions/${sessionId}/messages`, { params: { skip, limit } });
  return response.data?.messages || [];
};

export const postAiMessage = async (sessionId, payload) => {
  const response = await API.post(`/ai/sessions/${sessionId}/messages`, payload);
  return response.data;
};

export const confirmAiAction = async (actionId, confirmationToken) => {
  const response = await API.post(`/ai/actions/${actionId}/confirm`, {
    confirmationToken,
  });
  return response.data;
};

export const cancelAiAction = async (actionId) => {
  const response = await API.post(`/ai/actions/${actionId}/cancel`);
  return response.data?.action ?? response.data;
};
